import { Component } from '@angular/core';
import { FirstVisitCase } from '@kp/shared/first-visit/first-visit-case.enum';

@Component({
  selector: 'kp-screen-full-privacy',
  templateUrl: './screen-full-privacy.component.html',
})
export class ScreenFullPrivacyComponent {
  fromScreen = FirstVisitCase.onboarding;
}
